import React from "react";
import { useDispatch } from "react-redux";
import Modal from "../../components/ui/modal/Modal";

import { uiActions } from "../../store/redux/ui/ui-slice";

import classes from "./AnonLoginModal.module.css";
import AnonLoginBtn from "./components/anonymousLogin/AnonLoginBtn";
import LoginForm from "./LoginForm";

//when we have cart and not authienticated
//the popup raised on basket page when we try to purchase the product
//anonymous login on modal to login the app

const AnonLoginModal = () => {
  const dispatch = useDispatch();

  const CloseAuthPopHandler = () => {
    dispatch(uiActions.CloseAuthPop());
  };
  return (
    <Modal onClose={CloseAuthPopHandler}>
      <div className={classes.actions}>
        <div className={classes["close-btn"]} onClick={CloseAuthPopHandler}>
          <ion-icon name="close-circle-outline"></ion-icon>
        </div>
      </div>
      <LoginForm />
      {/* <span>OR</span> */}
      {/* <AnonLoginBtn /> */}
    </Modal>
  );
};

export default AnonLoginModal;
